import Breadcrumbs from "components/Common/Breadcrumb";
import AutoReloadList from "components/shared-components/AutoReload/AutoReloadList";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  CLIENT_TYPE_CONST,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import {
  MODE_INVOICE_ACTION,
  TYPE_ACTION_WORKFLOW,
  TYPE_INVOICE_ANOTHER,
} from "constants/IssueInvoiceConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { TENANT_CODE } from "constants/TennantConstant";
import { getResourceIdXML } from "helpers/form_helper";
import { getFileNameExcel, toastWarningIsAllStore } from "helpers/utils";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import NoteModal from "pages/DataFormatInvoice/modal/NoteModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import ProgressExport from "pages/ExportInvoice/ProgressExport";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import CompareInvoiceModal from "pages/IssueInvoice/modal/CompareInvoiceModal";
import ConfirmActionInvoice from "pages/IssueInvoice/modal/ConfirmActionInvoice";
import ConfirmCancelInvoiceModal from "pages/IssueInvoice/modal/ConfirmCancelInvoiceModal";
import PDFViewModal from "pages/IssueInvoice/modal/PDFViewModal";
import SignHSMModal from "pages/IssueInvoice/modal/SignHSMModal";
import TypeSignDigitalModal from "pages/IssueInvoice/modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "pages/IssueInvoice/modal/VerifyPinUSBModal";
import {
  COMMON_CONDITION_VISIBLE,
  KHMSHDON,
  checkDateWhenRelease,
  getRowInvoiceReplaceAdjustInfo,
  getTypeWorkflowMessage,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "pages/IssueInvoice/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  actionWorkflowIssueInvoice,
  cancelIssueInvoice,
  deleteIssueInvoice,
  downloadXmlIssueInvoice,
  exportInvoice,
  getCloneEnvoice,
  getDataLink,
  getInvoiceMinDate,
  listInvoiceSymbol,
  listIssueInvoice,
  releaseIssueInvoice,
  resetActionWorkflowIssueInvoice,
  resetAdjustIssueInvoice,
  resetBackupDataNew,
  resetCancelIssueInvoice,
  resetCloneEnvoice,
  resetDeleteIssueInvoice,
  resetDownloadXmlIssueInvoice,
  resetExportInvoice,
  resetGetInvoiceMinDate,
  resetListInvoiceSymbol,
  resetListIssueInvoice,
  resetReleaseIssueInvoice,
  resetReplaceIssueInvoice,
} from "store/actions";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  ADJUST_ISSUE_INVOICE_FAIL,
  ADJUST_ISSUE_INVOICE_SUCCESS,
  CANCEL_ISSUE_INVOICE_FAIL,
  CANCEL_ISSUE_INVOICE_SUCCESS,
  DELETE_ISSUE_INVOICE_FAIL,
  DELETE_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_SUCCESS,
  GET_INVOICE_MIN_DATE_FAIL,
  GET_INVOICE_MIN_DATE_SUCCESS,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import DetailBill from "./modal/DetailBill";

const ListBill = props => {
  const { filterList, pageView, title, titleManger, khhdonDefault } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["deliveryBill"]);
  const { addToast } = useToasts();
  const [dataExport, setDataExport] = useState({
    reportId: null,
    fileName: null,
  });
  const history = useHistory();
  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingList,
    errorList,
    list: issueInvoiceList,
    fileDownload,
    fileDownloadName,
    type,
    deleteInvoice,
    cancelInvoice,
    successClone,
    exportInvoiceWarehousesData,
    adjustIssueInvoice: adjustIssueInvoiceData,
    replaceIssueInvoice: replaceIssueInvoiceData,
    invoiceMaxMinDate,
    workflowInvoice,
    bkDataNew,
    exportInvoiceData,
  } = issueInvoice;

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const { errorList: errorInvoiceSymbolList, list: invoiceSymbolList } =
    invoiceSymbol;

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  // modalCheckRelease
  const childRef = useRef();
  const [rowRelease, setRowRelease] = useState(null);
  const [titleBodyCheckRelease, setTitleBodyCheckRelease] = useState("");
  const [modalCheckRelease, setModalCheckRelease] = useState(false);
  const toggleCheckReleaseModal = () =>
    setModalCheckRelease(!modalCheckRelease);

  // modalDenyRelease
  const [titleBodyDenyRelease, setTitleBodyDenyRelease] = useState("");
  const [modalDenyRelease, setModalDenyRelease] = useState(false);
  const toggleDenyReleaseModal = () => setModalDenyRelease(!modalDenyRelease);

  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // Confirm Cancel modal
  const [modalConfirmCancel, setModalConfirmCancel] = useState(false);
  const toggleConfirmCancelModal = () =>
    setModalConfirmCancel(!modalConfirmCancel);
  // CompareInvoiceModal
  const [dataCompare, setDataCompare] = useState(null);
  const [modalCompareInvoice, setModalCompareInvoice] = useState(false);
  const toggleCompareInvoiceModal = () =>
    setModalCompareInvoice(!modalCompareInvoice);
  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);
  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkFlow: null,
    titleModal: null,
    bodyModal: null,
  });
  // Lí do từ chối duyệt
  const [noteReject, setNoteReject] = useState(null);
  const [modalReject, setModalReject] = useState(false);
  const toggleRejectModal = () => setModalReject(!modalReject);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, buStoreHeader, finalListBuCode } =
    Dashboard;

  const [isEnterprise, setIsEnterprise] = useState(false);
  useEffect(() => {
    if (tenantCodeHeader) {
      setIsEnterprise(tenantCodeHeader === TENANT_CODE.GUARDIAN);
    }
  }, [tenantCodeHeader]);

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      issueInvoiceList.params.page = 1;
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      };
      resetDataFunc();
      getListInvoiceSymbol(KHMSHDON.DELIVERY_BILL);
      //   generateBtnFooter();
    }
  }, [finalBuInfo]);

  useEffect(() => {
    if (successClone && tenantCodeHeader) {
      issueInvoiceList.params.page = 1;
      resetDataFunc();
      addToast("Đã nhân bản tờ phiếu xuất kho", {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetCloneEnvoice());
    }
  }, [successClone, tenantCodeHeader]);

  // Get list KHHD
  const getListInvoiceSymbol = ttchung_khmshdon => {
    invoiceSymbolList.params.page = -1;
    invoiceSymbolList.params.sort = "name";
    invoiceSymbolList.params.columnFilter = {
      "filter[record_status]": "O",
      "filter[bu_code]": localStorage.getItem(BU_STORE_HEADER),
      "filter[khmhdon]": ttchung_khmshdon,
    };
    invoiceSymbolList.params.fields =
      "id,khmhdon,khhdon,bu_code,record_status,tenant_code,";
    dispatch(listInvoiceSymbol(invoiceSymbolList.params));
  };

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    issueInvoiceList.params.page = 1;
    issueInvoiceList.params.sizePerPage = 10;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };

    initColumn();
    return () => {
      dispatch(resetListIssueInvoice());
    };
  }, [dispatch, t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (issueInvoiceList) {
      setColumnsTable(initColumns);
    }

    if (issueInvoiceList.columnsVisibleHaveCode) {
      initColumn();
    }
  }, [issueInvoiceList]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  const [btnShowFooter, setBtnShowFooter] = useState({
    btnSubmitEdit: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
  });

  const [isSendSubmitEdit, setIsSendSubmitEdit] = useState(false);

  const generateBtnFooter = () => {
    setBtnShowFooter({
      btnSubmitEdit: {
        isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
        listConditionRow: [
          COMMON_CONDITION_VISIBLE.REPLACE,
          COMMON_CONDITION_VISIBLE.ADJUST,
        ],
        onClick: () => {
          setIsSendSubmitEdit(true);
        },
        toggleModal: null,
      },
    });
  };

  // Action Dispatch
  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
    }
  }, []);

  // Error Dispatch
  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListIssueInvoice());
    }

    if (errorInvoiceSymbolList) {
      addToast(
        errorInvoiceSymbolList.message ||
          t("message.list", {
            target: t("invoice_symbol"),
            status: t("message.error"),
          }),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListInvoiceSymbol());
    }
  }, [addToast, dispatch, errorInvoiceSymbolList, errorList, t]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }

        dispatch(resetDownloadXmlIssueInvoice());
        break;
      }
      case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
        if (!modalUSBSign) {
          console.log("jhahaha222233");
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_SUCCESS:
        addToast("Lập phiếu xuất kho thay thế thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        resetDataFunc();
        dispatch(resetReplaceIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_FAIL:
        if (
          replaceIssueInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập phiếu xuất kho thay thế thất bại, tồn tại phiếu xuất kho thay thế chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập phiếu xuất kho thay thế thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetReplaceIssueInvoice());
        break;

      case ADJUST_ISSUE_INVOICE_SUCCESS:
        addToast("Lập phiếu xuất kho điều chỉnh thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        resetDataFunc();
        dispatch(resetAdjustIssueInvoice());
        break;
      case ADJUST_ISSUE_INVOICE_FAIL:
        if (
          adjustIssueInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập phiếu xuất kho điều chỉnh thất bại, tồn tại phiếu xuất kho điều chỉnh chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập phiếu xuất kho điều chỉnh thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetAdjustIssueInvoice());
        break;

      case DELETE_ISSUE_INVOICE_SUCCESS:
        addToast("Xóa phiếu xuất kho thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        resetDataFunc();
        dispatch(resetDeleteIssueInvoice());
        break;
      case DELETE_ISSUE_INVOICE_FAIL:
        addToast("Xóa phiếu xuất kho thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDeleteIssueInvoice());
        break;

      case CANCEL_ISSUE_INVOICE_SUCCESS:
        addToast("Gửi yêu cầu hủy phiếu xuất kho thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmCancelModal();
        resetDataFunc();
        dispatch(resetCancelIssueInvoice());
        break;
      case CANCEL_ISSUE_INVOICE_FAIL:
        addToast("Gửi yêu cầu hủy phiếu xuất kho thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCancelIssueInvoice());
        break;
      default:
        break;
      case EXPORT_INVOICE_SUCCESS:
        dispatch(resetExportInvoice());
        setTimeout(() => {
          setDataExport({
            reportId: exportInvoiceData?.reportId,
            fileName: fileDownloadName,
          });
        });
        break;
      case EXPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        if (exportInvoiceData?.error?.response?.status === 413) {
          addToast("Vui lòng giảm bớt số cột cần xuất dữ liệu", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetExportInvoice());
        break;
      case GET_INVOICE_MIN_DATE_SUCCESS:
        if (!detailModal) {
          checkDateWhenRelease(
            invoiceMaxMinDate.data.min,
            invoiceMaxMinDate.data.max,
            new Date(rowRelease.ttchung_nlap * 1000),
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyDenyRelease(
                `Đã có phiếu xuất kho phát hành ngày ${maxDateLabel}. Vui lòng  cập nhật ngày lập của HĐ hiện tại về ${maxDateLabel} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiên tại).`
              );
              toggleDenyReleaseModal();
            },
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyCheckRelease(
                `Đang có Phiếu xuất kho lưu tạm có ngày lập (${minDateLabel}) nhỏ hơn ngày lập của phiếu xuất kho hiện tại (${nlapLabel}), bạn có muốn tiếp tục phát hành phiếu xuất kho này hay không?`
              );
              toggleCheckReleaseModal();
            },
            () => {
              releaseInvoiceFunc(rowRelease);
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      case GET_INVOICE_MIN_DATE_FAIL:
        if (!detailModal) {
          addToast(
            "Lấy thông tin ngày lập phiếu xuất kho lưu tạm xa nhất thất bại",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS: {
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow, true) +
          " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalWorkflow) {
          toggleWorkflowModal();
        }
        resetDataFunc();
        if (workflowInvoice.typeWorkflow === TYPE_ACTION_WORKFLOW.APPROVE) {
          toggleTypeSignModal();
        }
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      }
      case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkFlow, true) +
          " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowIssueInvoice());
        break;
    }
  }, [type]);

  const initColumn = () => {
    if (issueInvoiceList.columnsVisible) {
      for (const item of initColumns) {
        if (issueInvoiceList.columnsVisible[item.dataField] !== undefined) {
          item.hidden = !issueInvoiceList.columnsVisible[item.dataField];
        }
      }
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    // dispatch(setListVATInvoiceHaveCodeColumn(field, value));
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    issueInvoiceList.params.sort = sortField
      ? sortOrder + sortField
      : issueInvoiceList.params.sort;
    issueInvoiceList.params.columnFilter =
      { ...columnFilter, ...filterList } || {};
    issueInvoiceList.params.page = page || 1;
    issueInvoiceList.params.sizePerPage = sizePerPage || 10;
    resetDataFunc();
  };

  const onSearchAllHandle = value => {
    issueInvoiceList.params.keywords = value;
    resetDataFunc();
  };

  const resetFilterHandle = () => {
    initColumn();
    // Reset filter call api
    issueInvoiceList.params.columnFilter = {};
    delete issueInvoiceList.params.keywords;
    resetDataFunc();
  };

  const toggleDetailModal = (modeSet = "", isReloadPage) => {
    if (isReloadPage) {
      resetDataFunc();
      setDetailModal(!detailModal);
      return;
    }
    setDetailModal(!detailModal);
    switch (modeSet) {
      case issueInvoiceModeList.CREATE_DELIVERY_BILL_DETAIL:
      case issueInvoiceModeList.EDIT_DELIVERY_BILL_DETAIL:
        issueInvoiceList.params.page = 1;
        issueInvoiceList.params.sizePerPage = 10;
        resetDataFunc();
        break;
      default:
        break;
    }
  };

  const toastAddInvoice = () => {
    return addToast("Bạn chưa đăng ký sử dụng loại phiếu xuất kho này", {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const createInvoiceHanler = () => {
    if (toastWarningIsAllStore(addToast)) {
      return;
    }
    if (finalBuInfo) {
      if (finalBuInfo.ctu === 1) {
        actionCreate();
      } else {
        toastAddInvoice();
      }
    }
  };

  const actionCreate = () => {
    setDataConfirmAction(null);
    setDataDetail({});
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE:
        setMode(issueInvoiceModeList.CREATE_DELIVERY_BILL_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };
  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      getListInvoiceSymbol(row.ttchung_khmshdon);
      if (row.adjust_mod) {
        setDataConfirmAction({
          typeAdjust: row.adjust_mod,
        });
      } else {
        setDataConfirmAction(null);
      }
      setDataDetail({
        id: row.id,
        tthdlquan_tchdon: row.tthdlquan_tchdon,
        root: row.root,
        child: row.child,
        tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
        tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
        tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
        tthdlquan_shdclquan: row.tthdlquan_shdclquan,
        tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
      });
      switch (pageView) {
        case issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE:
        case issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE:
          setMode(issueInvoiceModeList.VIEW_DELIVERY_BILL_DETAIL);
          break;
        default:
          break;
      }
      toggleDetailModal();
    },
  };

  const checkBeforeRelease = row => {
    if (toastWarningIsAllStore(addToast)) {
      return;
    }
    setRowRelease(row);
    dispatch(
      getInvoiceMinDate(
        row?.ttchung_khmshdon,
        row?.ttchung_khhdon,
        row?.bu_code
      )
    );
  };

  const releaseInvoiceFunc = row => {
    setTransferData({
      id: row.id,
      mst: row.nban_mst,
      resource_id: getResourceIdXML(row.resource_list, "raw"),
      type: TYPE_TRANSFER.INVOICE,
      invoice_type: row.invoice_type,
    });
    toggleTypeSignModal();
  };

  const cloneEnvoice = id => {
    let approveStatus = undefined;
    if (isRoleAccountant) {
      approveStatus = APPROVE_STATUS_A;
    }
    dispatch(
      getCloneEnvoice(id, TYPE_INVOICE_ANOTHER.DELIVERY_BILL, approveStatus)
    );
  };
  const listRowAction = [
    {
      icon: <i className="bx bx-send text-success" />,
      text: "Gửi duyệt phiếu xuất kho",
      isShow: finalBuInfo?.need_approve === 1 && isRoleStore,
      conditionVisible: COMMON_CONDITION_VISIBLE.SEND_APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.id,
          typeWorkFlow: TYPE_ACTION_WORKFLOW.SUBMIT,
          titleModal: "Xác nhận gửi duyệt phiếu xuất kho",
          bodyModal: "Hệ thống sẽ gửi duyệt phiếu xuất kho này",
        });
        toggleWorkflowModal();
      },
    },
    {
      icon: <i className="bx bxs-check-circle text-success" />,
      text: "Duyệt phiếu xuất kho",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.id,
          typeWorkFlow: TYPE_ACTION_WORKFLOW.APPROVE,
          titleModal: "Xác nhận duyệt phát hành phiếu xuất kho này",
          bodyModal: "Hệ thống sẽ duyệt phát hành phiếu xuất kho này",
        });
        setTransferData({
          id: row.id,
          mst: row.nban_mst,
          resource_id: getResourceIdXML(row.resource_list, "raw"),
          type: TYPE_TRANSFER.INVOICE,
          invoice_type: row.invoice_type,
        });
        toggleWorkflowModal();
      },
    },
    {
      icon: <i className="bx bxs-x-circle text-danger" />,
      text: "Từ chối duyệt phiếu xuất kho",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.REJECT_APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.id,
          typeWorkFlow: TYPE_ACTION_WORKFLOW.REJECT,
          titleModal: "Xác nhận từ chối duyệt phát hành phiếu xuất kho này",
          bodyModal: "Lý do từ chối",
        });
        toggleWorkflowModal();
      },
    },
    // Phat hanh truong hop k có cap duyet
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Phát hành phiếu",
      isShow: finalBuInfo?.need_approve === 0,
      conditionVisible: COMMON_CONDITION_VISIBLE.RELEASE,
      onClick: row => {
        checkBeforeRelease(row);
      },
    },
    // Phat hanh truong hop có cap duyet và đã duyệt (Role kế toán)
    {
      icon: <i className="bx bx-send text-success" />,
      text: "Phát hành phiếu đã duyệt",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.RELEASE_APPROVED,
      onClick: row => {
        checkBeforeRelease(row);
      },
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      onClick: row => {
        showPdfById(row.id);
      },
    },
    {
      icon: <i className="far fa-newspaper text-success" />,
      isDropdown: true,
      classDropdown: "dropdown-menu-2",
      listDropdown: [
        {
          icon: <i className="bx bx-rotate-left font-size-18 text-primary" />,
          text: "Thay thế",
          isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
          conditionVisible: COMMON_CONDITION_VISIBLE.REPLACE,
          onClick: row => {
            setDataConfirmAction({
              id: row.id,
              mode: MODE_INVOICE_ACTION.REPLACE,
              pattern: row.ttchung_khmshdon,
              serial: row.ttchung_khhdon,
              invoiceNo: row.ttchung_shdon,
              nlap: row.ttchung_nlap,
            });
            toggleConfirmActionModal();
          },
        },
        {
          icon: <i className="bx bx-edit font-size-18 text-primary" />,
          text: "Điều chỉnh",
          isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
          conditionVisible: COMMON_CONDITION_VISIBLE.ADJUST,
          onClick: row => {
            setDataConfirmAction({
              id: row.id,
              mode: MODE_INVOICE_ACTION.ADJUST,
              pattern: row.ttchung_khmshdon,
              serial: row.ttchung_khhdon,
              invoiceNo: row.ttchung_shdon,
              nlap: row.ttchung_nlap,
            });
            toggleConfirmActionModal();
          },
        },
        {
          icon: <i className="bx bx-trash font-size-18 text-danger" />,
          text: "Hủy",
          isShow:
            buStoreHeader !== ALL_STORE &&
            buStoreHeader !== ALL_BU &&
            !isRoleStore,
          conditionVisible: COMMON_CONDITION_VISIBLE.CANCEL,
          onClick: row => {
            setDataViewDocument({
              id: row.id,
              gui_hdth: row.gui_hdth,
            });
            toggleConfirmCancelModal();
          },
        },
      ],
      text: "Nghiệp vụ",
    },
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật phiếu xuất kho",
      isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.EDIT,
      onClick: row => {
        if (row.tthdlquan_tchdon) {
          let mode = null;
          switch (row.tthdlquan_tchdon) {
            case "1":
              mode = MODE_INVOICE_ACTION.REPLACE;
              break;
            case "2":
              mode = MODE_INVOICE_ACTION.ADJUST;
              break;
            default:
              break;
          }
          setDataConfirmAction({
            modeEdit: mode,
            typeAdjust: row.adjust_mod,
          });
        } else {
          setDataConfirmAction(null);
        }
        setDataDetail({
          id: row.id,
          tthdlquan_tchdon: row.tthdlquan_tchdon,
          root: row.root,
          child: row.child,
          tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
          tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
          tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
          tthdlquan_shdclquan: row.tthdlquan_shdclquan,
          tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
        });
        switch (pageView) {
          case issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE:
          case issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE:
            setMode(issueInvoiceModeList.EDIT_DELIVERY_BILL_DETAIL);
            break;
          default:
            break;
        }
        toggleDetailModal();
      },
    },
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download XML",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        let mltdiep = null;
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else if (row.auth_status === AUTH_STATUS_APPROVE) {
          type = "tct-response";
          switch (row.invoice_type) {
            // có mã
            case "1":
              mltdiep = "202";
              break;
            // không mã
            case "0":
              mltdiep = "204";
              break;
            default:
              break;
          }
        } else {
          type = "signed";
        }
        resource_id = getResourceIdXML(row.resource_list, type, mltdiep);
        if (resource_id) {
          dispatch(
            downloadXmlIssueInvoice(
              resource_id,
              row.ttchung_thdon,
              "blob",
              TYPE_INVOICE_ANOTHER.DELIVERY_BILL
            )
          );
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Xóa bỏ",
      isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.DELETE,
      onClick: row => {
        setDataViewDocument({
          id: row.id,
        });
        toggleConfirmDeleteModal();
      },
    },
    {
      icon: <i className="fas fa-copy font-size-16 text-success"></i>,
      isShow: finalBuInfo?.can_clone === 1,
      text: "Copy phiếu xuất kho này",
      conditionVisible: {
        tthdlquan_tchdon: [null],
      },
      onClick: row => {
        cloneEnvoice(row.id);
      },
    },
    // {
    //   icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
    //   text: "Download PDF",
    //   conditionVisible: {
    //     resource_id: [],
    //   },
    //   onClick: row => {},
    // },
  ];

  const actionReplaceOrAdjustInvoice = (typeAdjust, finalSerial) => {
    setDataConfirmAction({
      ...dataConfirmAction,
      typeAdjust,
      finalSerial,
    });
    setDataDetail({ id: dataConfirmAction.id });
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE:
        setMode(issueInvoiceModeList.EDIT_DELIVERY_BILL_DETAIL);
        break;
      default:
        break;
    }
    toggleDetailModal();
  };

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: "Xuất danh sách phiếu xuất kho",
      isDisabled: issueInvoiceList.totalCount === 0,
      isLoading: exportInvoiceWarehousesData.loading,
      loadingText: "Đang xuất danh sách phiếu xuất kho",
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          ...issueInvoiceList.params.columnFilter,
          sort: issueInvoiceList.params.sort
            ? issueInvoiceList.params.sort
            : "-checker_date",
          keywords: issueInvoiceList.params.keywords,
        };
        dispatch(
          exportInvoice(
            objectExport,
            getFileNameExcel("DanhSachPhieuXuatKhoVCNoiBo"),
            "invoice-warehouses/export-console",
            TYPE_REPORT.INVOICE_WAREHOUSES
          )
        );
      },
    },
  ];

  const exportFormatData = () => {
    let objectExport = {};
    columnsTable
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        // Format data
        switch (formatData.dataField) {
          case "auth_status":
            for (const key in selectFilterAuthStatus) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterAuthStatus[key];
            }
            break;
          //   case "approve_status":
          //     for (const key in selectFilterApproveStatus) {
          //       objectExport[
          //         `columns[${formatData.dataField}][mapping][${key}]`
          //       ] = selectFilterApproveStatus[key];
          //     }
          //     break;
          case "sent":
            objectExport[`columns[${formatData.dataField}][mapping][0]`] =
              "Chưa gửi mail";
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "Đã gửi mail";
            break;
          case "ttchung_khmshdon":
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "HÓA ĐƠN GTGT";
            objectExport[`columns[${formatData.dataField}][mapping][2]`] =
              "HÓA ĐƠN BH";
            break;
          case "ttchung_shdon":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "ttchung_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "ttoan_tgtttbso":
            objectExport[`columns[${formatData.dataField}][type]`] = "currency";
            break;
          default:
            break;
        }
        // Format style
        switch (formatData.dataField) {
          case "nmua_ten":
            objectExport[
              `columns[${formatData.dataField}][contentOptions][alignment][wrapText]`
            ] = true;
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][width]`
            ] = 80;
            break;
          default:
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][autoSize]`
            ] = true;
            break;
        }
        //
        const value = formatData.text;
        objectExport[key] = value;

        return formatData;
      });
    return objectExport;
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let id = row.id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    info = getRowInvoiceReplaceAdjustInfo(
      row,
      setDataCompare,
      dispatch,
      getDataLink,
      toggleCompareInvoiceModal
    );
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
          {info}
        </div>
        {row.auto_sign === 1 && (
          <Badge
            style={{ width: "110px", whiteSpace: "initial", marginTop: "2px" }}
            className={`font-size-10 text-warning`}
            pill
          >
            Tự động phát hành
          </Badge>
        )}
      </React.Fragment>
    );
  };

  const getApproveStatus = row => {
    let status = row.approve_status;
    let note_deny = row.approve_note?.workflowNote;
    let infoError = null;
    if (status === APPROVE_STATUS_R) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setNoteReject(note_deny);
            toggleRejectModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1" title={note_deny}>
          <Badge
            className={`font-size-12 ${commonStatus?.APPROVE_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.APPROVE_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    // [AUTH_STATUS_REPLACE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REPLACE]?.text, // "Thay thế",
    // [AUTH_STATUS_EDIT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_EDIT]?.text, // "Điều chỉnh",
    [AUTH_STATUS_CANCEL_WAITING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL_WAITING]?.text, // "Hủy",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const getSelectFilterApproveStatus = () => {
    const filter = {};
    let listFilter = [
      APPROVE_STATUS_M,
      APPROVE_STATUS_P,
      APPROVE_STATUS_A,
      APPROVE_STATUS_R,
    ];
    if (isRoleAccountant) {
      listFilter = [APPROVE_STATUS_P, APPROVE_STATUS_A];
    }
    for (const item of listFilter) {
      if (selectFilterApproveStatus[item]) {
        filter[item] = selectFilterApproveStatus[item];
      }
    }
    return filter;
  };

  const selectFilterApproveStatus = {
    [APPROVE_STATUS_M]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_M]?.text, // "Lưu tạm",
    [APPROVE_STATUS_P]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_P]?.text, // "Gửi chờ duyệt",
    [APPROVE_STATUS_A]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_A]?.text, // "Đã duyệt",
    [APPROVE_STATUS_R]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_R]?.text, // "Từ chối duyệt",
  };

  const getClientType = row => {
    let client_type = row.client_type;
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.CLIENT_TYPE[client_type]?.badgeColor}`}
            pill
          >
            {commonStatus?.CLIENT_TYPE[client_type]?.text}
          </Badge>
        </div>
      </React.Fragment>
    );
  };

  const getSelectFilterClientType = () => {
    return selectFilterClientType;
  };

  const selectFilterClientType = {
    // [CLIENT_TYPE_CONST.SALE]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE]?.text,
    // [CLIENT_TYPE_CONST.SALE_ADJ]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE_ADJ]?.text,
    // [CLIENT_TYPE_CONST.IBT_GTGT]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_GTGT]?.text,
    // [CLIENT_TYPE_CONST.GRA]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA]?.text,
    // [CLIENT_TYPE_CONST.GRA_ADJ]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA_ADJ]?.text,
    [CLIENT_TYPE_CONST.IBT]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT]?.text,
    [CLIENT_TYPE_CONST.IBT_CSM]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_CSM]?.text,
  };

  const initColumns = [
    // {
    //   dataField: "pban",
    //   text: t("table.version"),
    //   // sort: true,
    //   // filter: textFilter({
    //   //   placeholder: t("placeholder.enter", {
    //   //     title: t("table.message_sender"),
    //   //   }),
    //   // }),
    // },
    {
      dataField: "id",
      text: "id",
      sort: true,
      hidden: env.API_AIR_BRAKE_ENV !== "dev" || isEnterprise,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px" },
      }),
    },
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { maxWidth: "120px" },
      }),
      hidden: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
    },
    {
      dataField: "client_ref_uuid",
      text: "Số tham chiếu",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "120px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ maxWidth: "120px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "ttchung_thdon",
      text: t("table.invoice_name"),
      sort: true,
      hidden: isEnterprise,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "pending_van",
      text: "Trạng thái gửi lên VAN",
      hidden: true,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-1">
            <Badge
              style={{ width: "110px", whiteSpace: "initial" }}
              className={`font-size-12 ${
                cellContent ? "badge-soft-warning" : "badge-soft-success"
              }`}
              pill
            >
              {cellContent ? "Chưa gửi" : "Đã gửi"}
            </Badge>
          </div>
        );
      },
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: {
          0: "Đã gửi",
          1: "Chưa gửi",
        },
        style: { width: "100px" },
      }),
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
        style: { maxWidth: "129px" },
      }),
    },
    {
      dataField: "approve_status",
      text: "TT duyệt",
      hidden: finalBuInfo?.need_approve === 0,
      formatter: (cellContent, row) => getApproveStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterApproveStatus(),
        style: { width: "60px" },
      }),
    },
    // {
    //   dataField: "ttchung_khmshdon",
    //   text: t("table.invoice_model_number_symbol"),
    //   hidden: true,
    // },
    {
      dataField: "ttchung_khhdon",
      text: t("table.invoice_symbol"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "100px" },
      }),
      formatter: (cellContent, row) =>
        row.ttchung_khmshdon + row.ttchung_khhdon,
    },
    {
      dataField: "ttchung_shdon",
      text: "Số HĐ",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "100px" },
      }),
      formatter: (cellContent, row) => {
        return cellContent !== "0" && cellContent ? cellContent : "Chờ cấp số";
      },
    },
    {
      dataField: "ttchung_nlap",
      text: t("table.date_created"),
      formatter: (cellContent, row) =>
        tableFormateDate(row.ttchung_nlap, false, true),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "nmua_mst",
      text: t("form.nmua_mst"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: isEnterprise,
    },
    {
      dataField: "nmua_ten",
      text: t("form.nmua_ten"),
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "150px" },
      }),
      formatter: (cell, row) => {
        return (
          <div style={{ width: "150px", whiteSpace: "initial" }}>{cell}</div>
        );
      },
    },
    {
      dataField: "display_name",
      fieldSearch: "display_name",
      text: t("table.maker_id"),
      sort: true,
      hidden: isEnterprise,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { minWidth: "75px" },
      }),
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      hidden: isEnterprise,
      sort: true,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={issueInvoiceList.params.columnFilter}
        />
      ),
    },
    {
      dataField: "client_type",
      text: "Nguồn",
      hidden: !isEnterprise,
      formatter: (cellContent, row) => getClientType(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: getSelectFilterClientType(),
        style: { width: "138px" },
      }),
    },
  ];

  const resetDataFunc = (showLoading = true) => {
    // Role kế toán chỉ xem hóa đơn chờ duyệt và đã duyệt
    if (
      isRoleAccountant &&
      finalBuInfo?.need_approve === 1 &&
      !issueInvoiceList.params.columnFilter["filter[approve_status]"]
    ) {
      issueInvoiceList.params.columnFilter = {
        ...issueInvoiceList.params.columnFilter,
        "filter[approve_status][in]": [APPROVE_STATUS_P, APPROVE_STATUS_A],
      };
    }
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filterList,
    };
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        TYPE_INVOICE_ANOTHER.DELIVERY_BILL,
        showLoading
      )
    );
  };

  return (
    <React.Fragment>
      <div className="page-content badge-soft ">
        <MetaTags>
          <title>{t(title)}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title={t(titleManger)}
            breadcrumbItem={t(title) + ` (${issueInvoiceList.totalCount})`}
          />
          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              <AutoReloadList
                listData={issueInvoiceList.items}
                dataCheck={bkDataNew}
                actionReset={() => {
                  dispatch(resetBackupDataNew());
                }}
                actionReload={() => {
                  resetDataFunc(false);
                }}
              />
              {/* CheckRelease modal */}
              <ConfirmModal
                isOpen={modalCheckRelease}
                titleHeader={"Xác nhận Phát hành phiếu xuất kho"}
                titleBody={titleBodyCheckRelease}
                onConfirm={note => {
                  toggleCheckReleaseModal();
                  if (!detailModal) {
                    // phát hành ngoài list
                    releaseInvoiceFunc(rowRelease);
                  } else {
                    // phát hành trong detail
                    childRef?.current?.releaseFromDetail();
                  }
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleCheckReleaseModal}
              />
              {/* CheckRelease modal */}
              <ConfirmModal
                isOpen={modalDenyRelease}
                titleHeader={"Từ chối phát hành phiếu xuất kho"}
                titleBody={titleBodyDenyRelease}
                onConfirm={note => {
                  toggleDenyReleaseModal();
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleDenyReleaseModal}
                isShowBtnConfirm={false}
              />
              {/* Deny modal */}
              <ConfirmModal
                isOpen={modalConfirmDelete}
                titleHeader={"Xác nhận xóa phiếu xuất kho"}
                titleBody={"Hệ thống sẽ thực hiện xóa phiếu xuất kho này ?"}
                isDisableButton={deleteInvoice.loading}
                onConfirm={note => {
                  dispatch(
                    deleteIssueInvoice(
                      dataViewDocument.id,
                      TYPE_INVOICE_ANOTHER.DELIVERY_BILL
                    )
                  );
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleConfirmDeleteModal}
              />
              {/* Cancel modal */}
              <ConfirmCancelInvoiceModal
                isOpen={modalConfirmCancel}
                titleHeader={"Xác nhận gửi thông báo hủy phiếu xuất kho"}
                titleBody={"Nhập lí do hủy phiếu xuất kho ?"}
                isDisableButton={cancelInvoice.loading}
                isRequireNote={false}
                isHaveNote={true}
                onConfirm={(note, listUploadId) => {
                  let type = undefined;
                  if (dataViewDocument.gui_hdth === 1) {
                    type = 1;
                  }
                  dispatch(
                    cancelIssueInvoice(
                      [{ id: dataViewDocument.id, ldo: note }],
                      type,
                      TYPE_INVOICE_ANOTHER.DELIVERY_BILL,
                      listUploadId
                    )
                  );
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleConfirmCancelModal}
              />
              <ConfirmActionInvoice
                confirmActionData={dataConfirmAction}
                isOpen={modalConfirmAction}
                toggle={toggleConfirmActionModal}
                actionReplaceOrAdjustInvoice={actionReplaceOrAdjustInvoice}
              />
              <CompareInvoiceModal
                showPdfById={showPdfById}
                setDataCompare={setDataCompare}
                dataCompare={dataCompare}
                isOpen={modalCompareInvoice}
                toggle={toggleCompareInvoiceModal}
              />
              {/* PDFViewModal */}
              <PDFViewModal
                isOpen={modalPdfView}
                dataViewDocument={dataViewDocument}
                toggle={togglePdfViewModal}
              ></PDFViewModal>
              {/* ErrorReleaseModal */}
              <ErrorReleaseModal
                isOpen={modalErrorRelease}
                toggle={toggleErrorReleaseModal}
                id={idRelease}
                path={"invoice-tickets"}
              />
              {/* HistoryTransferModal */}
              <HistoryTransferModal
                isOpen={modalHistoryTransfer}
                toggle={toggleHistoryTransferModal}
                id={idHistory}
                path={"invoice-tickets"}
              />
              {/* Detail Modal */}
              <DetailBill
                ref={childRef}
                btnShowFooter={btnShowFooter}
                dataDetail={dataDetail}
                dataConfirmAction={dataConfirmAction}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
                pageView={pageView}
                showPdfById={showPdfById}
                khhdonDefault={khhdonDefault}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.DELIVERY_BILL}
                invoiceSymbolList={invoiceSymbolList.items}
                isRoleStore={isRoleStore}
                isRoleAccountant={isRoleAccountant}
                setTitleBodyDenyRelease={setTitleBodyDenyRelease}
                toggleDenyReleaseModal={toggleDenyReleaseModal}
                setTitleBodyCheckRelease={setTitleBodyCheckRelease}
                toggleCheckReleaseModal={toggleCheckReleaseModal}
              />
              {/* Hình thức ký modal */}
              <TypeSignDigitalModal
                t={t}
                isOpen={modalTypeSign}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.DELIVERY_BILL}
                transferData={transferData}
                toggle={toggleTypeSignModal}
                toggleUSBSignModal={toggleUSBSignModal}
                toggleHSMSignModal={toggleHSMSignModal}
              />
              {/* Ký USB Modal */}
              <VerifyPinUSBModal
                t={t}
                isOpen={modalUSBSign}
                downloadXmlFunc={downloadXmlIssueInvoice}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.DELIVERY_BILL}
                transferData={transferData}
                resetDataFunc={resetDataFunc}
                toggle={toggleUSBSignModal}
              />
              {/* Ký HSM Modal */}
              <SignHSMModal
                t={t}
                isOpen={modalHSMSign}
                invoice_type={transferData?.invoice_type}
                transferData={transferData}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.DELIVERY_BILL}
                resetDataFunc={resetDataFunc}
                releaseFunc={releaseIssueInvoice}
                resetReleaseFunc={resetReleaseIssueInvoice}
                toggle={toggleHSMSignModal}
              />
              {/* WORKFLOW modal */}
              <ConfirmModal
                isOpen={modalWorkflow}
                titleHeader={dataWorkflow.titleModal}
                titleBody={dataWorkflow.bodyModal}
                isDisableButton={workflowInvoice.loading}
                isHaveNote={
                  dataWorkflow.typeWorkFlow === TYPE_ACTION_WORKFLOW.REJECT
                }
                onConfirm={note => {
                  dispatch(
                    actionWorkflowIssueInvoice(
                      dataWorkflow.id,
                      dataWorkflow.typeWorkFlow,
                      note
                    )
                  );
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleWorkflowModal}
              />
              {/*Từ chối duyệt Modal */}
              <NoteModal
                isOpen={modalReject}
                toggle={toggleRejectModal}
                note={noteReject}
                titleNote={"Lí do từ chối duyệt"}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                {dataExport?.reportId && (
                  <ProgressExport
                    funcComplete={() => {
                      setDataExport({
                        reportId: null,
                        fileName: null,
                      });
                    }}
                    idReport={dataExport?.reportId}
                    fileName={dataExport?.fileName}
                  />
                )}
                <CardBody>
                  <RemoteDataTable
                    // selectRow={selectRowCheckbox}
                    // onRowsSelect={onRowsSelect}
                    // expandRow={expandRowTable}
                    keyField="id"
                    data={issueInvoiceList.items}
                    columns={columnsTable}
                    page={issueInvoiceList.params.page}
                    sizePerPage={issueInvoiceList.params.sizePerPage}
                    totalSize={issueInvoiceList.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={
                      isRoleStore
                        ? listRowAction.filter(
                            item =>
                              item.text !== "Phát hành phiếu" &&
                              item.text !== "Hủy"
                          )
                        : listRowAction
                    }
                    loading={loadingList}
                    resetFilterHandle={resetFilterHandle}
                  >
                    <Button
                      type="button"
                      color="primary"
                      className="me-2 btn-label"
                      onClick={() => {
                        if (toastWarningIsAllStore(addToast)) {
                          return;
                        }
                        history.push("/invoice-warehouses/create");
                      }}
                    >
                      <i className="bx bx-plus label-icon" />
                      {t("table.btn_create_bill")}
                    </Button>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

ListBill.propTypes = {
  filterList: PropTypes.object.isRequired,
  pageView: PropTypes.string,
  title: PropTypes.string,
  titleManger: PropTypes.string,
  khhdonDefault: PropTypes.string,
};

ListBill.defaultProps = {
  filterList: {},
  pageView: "",
};

export default ListBill;
